import { AxiosError, AxiosResponse } from 'axios';
import { ApiResponse } from '../types/api';
import { API_ORIGIN } from '../config';

/**
 * API URL 환경 변수 또는 기본값
 */
export const API_URL = API_ORIGIN;

/**
 * API 응답을 처리하는 표준 함수
 * @param response Axios 응답 객체
 * @returns 표준화된 API 응답 객체
 */
export const handleApiResponse = <T>(response: AxiosResponse): ApiResponse<T> => {
  return {
    success: true,
    data: response.data,
    message: '성공'
  };
};

/**
 * API 오류를 처리하는 표준 함수
 * @param error Axios 오류 객체
 * @returns 표준화된 API 오류 응답
 */
export const handleApiError = <T>(error: AxiosError): ApiResponse<T> => {
  console.error('[memberApi] 오류 처리:', error);
  
  if (error.response) {
    const data = error.response.data as { message?: string } | undefined;
    const errorMessage = data?.message || '서버 오류 발생';
    return {
      success: false,
      data: null,
      message: errorMessage
    };
  }
  
  return {
    success: false,
    data: null,
    message: '네트워크 오류 발생'
  };
};

/**
 * API 요청 타임아웃 (밀리초)
 */
export const API_TIMEOUT = 10000;

/**
 * 인증 토큰 가져오기
 * @returns 로컬 스토리지에서 가져온 인증 토큰
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

/**
 * 인증 헤더 생성
 * @returns 인증 헤더 객체
 */
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}; 

export const logApiError = (...args: unknown[]): void => {
  console.error('[API ERROR]', ...args);
};